import {
  browserFastApiClient,
  requireFastApiAccessToken,
} from "@/core/fastapi";
import {
  getTopicsApiCrud,
  type GetTopicsRequest,
  type IdentifiedTopic,
} from "@/generated/fastapi";

export async function getTopics(
  accessToken: string | null | undefined,
  request: GetTopicsRequest,
): Promise<IdentifiedTopic[]> {
  const response = await getTopicsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error("Failed to retrieve topics");
  }

  return response.data;
}
